import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { adminAPI } from '../services/api'

export const useSystemSettings = () => {
  return useQuery({
    queryKey: ['admin', 'system-settings'],
    queryFn: async () => {
      const response = await adminAPI.get('/settings')
      return response.data.data
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  })
}

export const useUpdateSystemSettings = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (settings) => {
      const response = await adminAPI.put('/settings', settings)
      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['admin', 'system-settings'])
    },
  })
}